<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <h5 class="mb-0">
          <feather-icon icon="HashIcon" class="mr-2" />
          Configurar Triggers do Chat
        </h5>
      </b-card-header>

      <b-card-body>
        <!-- Formulário para adicionar novo trigger -->
        <b-card variant="light" class="mb-4">
          <b-card-header>
            <h6 class="mb-0">
              <feather-icon icon="PlusIcon" class="mr-1" />
              Adicionar Novo Trigger
            </h6>
          </b-card-header>
          <b-card-body>
            <b-form @submit.prevent="adicionarTrigger">
              <b-row>
                <b-col md="6">
                  <b-form-group label="Palavra-chave Trigger" description="Digite a palavra ou frase que ativará o trigger (ex: #desconto, #oferta)">
                    <b-form-input
                      v-model="novoTrigger.trigger"
                      placeholder="Ex: desconto"
                      required
                      @input="formatarTrigger"
                      @keypress="validarCaracteres"
                    />
                  </b-form-group>
                </b-col>
                <!-- <b-col md="6">
                  <b-form-group label="Tempo de Ativação" description="Tempo após o início da live para ativar o trigger">
                    <b-row>
                      <b-col cols="6">
                        <b-form-input
                          v-model.number="novoTrigger.minutes"
                          type="number"
                          min="0"
                          placeholder="Minutos"
                          required
                        />
                      </b-col>
                      <b-col cols="6">
                        <b-form-input
                          v-model.number="novoTrigger.seconds"
                          type="number"
                          min="0"
                          max="59"
                          placeholder="Segundos"
                          required
                        />
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col> -->
              </b-row>

              <b-form-group label="Resposta Automática" description="A mensagem que será enviada automaticamente no tempo especificado">
                <b-form-textarea
                  v-model="novoTrigger.resposta"
                  placeholder="Digite a mensagem que será enviada automaticamente..."
                  rows="3"
                  required
                />
              </b-form-group>

              <b-form-group>
                <b-form-checkbox v-model="novoTrigger.ativo">
                  Trigger ativo (se desmarcado, o trigger não será executado)
                </b-form-checkbox>
              </b-form-group>

              <div class="d-flex justify-content-end">
                <b-button type="submit" variant="primary" :disabled="!isFormValid">
                  <feather-icon icon="PlusIcon" class="mr-1" />
                  Adicionar Trigger
                </b-button>
              </div>
            </b-form>
          </b-card-body>
        </b-card>

        <!-- Lista de triggers existentes -->
        <b-card>
          <b-card-header>
            <h6 class="mb-0">
              <feather-icon icon="ListIcon" class="mr-1" />
              Triggers Configurados ({{ triggers.length }})
            </h6>
          </b-card-header>
          <b-card-body>
            <div v-if="triggers.length === 0" class="text-center text-muted py-4">
              <feather-icon icon="HashIcon" size="48" class="mb-3" />
              <p class="mb-0">Nenhum trigger configurado ainda</p>
              <small>Adicione triggers para automatizar respostas no chat</small>
            </div>

            <div v-else>
              <b-table
                :items="triggers"
                :fields="tableFields"
                striped
                hover
                responsive
                show-empty
              >
                <template #cell(trigger)="data">
                  <span class="trigger-badge">{{ data.value }}</span>
                </template>

                <template #cell(ativo)="data">
                  <b-badge :variant="data.value ? 'success' : 'secondary'">
                    {{ data.value ? 'Ativo' : 'Inativo' }}
                  </b-badge>
                </template>

                <!-- <template #cell(tempo)="data">
                  {{ formatTempo(data.value) }}
                </template> -->

                <template #cell(resposta)="data">
                  <div class="text-truncate" style="max-width: 250px;" :title="data.value">
                    {{ data.value }}
                  </div>
                </template>

                <template #cell(acoes)="data">
                  <div class="d-flex gap-1">
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      @click="editarTrigger(data.index)"
                      v-b-tooltip.hover
                      title="Editar trigger"
                    >
                      <feather-icon icon="EditIcon" size="14" />
                    </b-button>
                    
                    <b-button
                      size="sm"
                      :variant="data.item.ativo ? 'outline-warning' : 'outline-success'"
                      @click="toggleTriggerStatus(data.index)"
                      v-b-tooltip.hover
                      :title="data.item.ativo ? 'Desativar trigger' : 'Ativar trigger'"
                    >
                      <feather-icon :icon="data.item.ativo ? 'PauseIcon' : 'PlayIcon'" size="14" />
                    </b-button>

                    <b-button
                      size="sm"
                      variant="outline-danger"
                      @click="removerTrigger(data.index)"
                      v-b-tooltip.hover
                      title="Remover trigger"
                    >
                      <feather-icon icon="TrashIcon" size="14" />
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
          </b-card-body>
        </b-card>

        <!-- Botões de ação -->
        <div class="d-flex justify-content-between mt-4">
          <div>
            <b-button variant="outline-secondary" @click="limparTodos" :disabled="triggers.length === 0">
              <feather-icon icon="TrashIcon" class="mr-1" />
              Limpar Todos
            </b-button>
          </div>
          <div>
            <b-button variant="success" @click="salvarTriggers" :disabled="!hasChanges">
              <feather-icon icon="SaveIcon" class="mr-1" />
              Salvar Configurações
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <!-- Modal de edição -->
    <b-modal
      v-model="showEditModal"
      title="Editar Trigger"
      @ok="salvarEdicao"
      @cancel="cancelarEdicao"
      ok-title="Salvar"
      cancel-title="Cancelar"
    >
      <b-form v-if="triggerEditando">
        <b-form-group label="Palavra-chave Trigger">
          <b-form-input
            v-model="triggerEditando.trigger"
            placeholder="Ex: desconto"
            required
            @input="formatarTriggerEdicao"
            @keypress="validarCaracteres"
          />
        </b-form-group>

        <!-- <b-form-group label="Tempo de Ativação">
          <b-row>
            <b-col cols="6">
              <b-form-input
                v-model.number="triggerEditando.minutes"
                type="number"
                min="0"
                placeholder="Minutos"
                required
              />
            </b-col>
            <b-col cols="6">
              <b-form-input
                v-model.number="triggerEditando.seconds"
                type="number"
                min="0"
                max="59"
                placeholder="Segundos"
                required
              />
            </b-col>
          </b-row>
        </b-form-group> -->

        <b-form-group label="Resposta Automática">
          <b-form-textarea
            v-model="triggerEditando.resposta"
            rows="3"
            required
          />
        </b-form-group>

        <b-form-group>
          <b-form-checkbox v-model="triggerEditando.ativo">
            Trigger ativo
          </b-form-checkbox>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BButton, BTable, BBadge, BModal, BRow, BCol } from 'bootstrap-vue'
import { youtubeService } from '@/services/WebinarSimulator/youtubeService'

export default {
  name: 'ChatTriggers',
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    BTable,
    BBadge,
    BModal,
    BRow,
    BCol,
  },
  props: {
    webinarioData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      triggers: [],
      hasChanges: false,
      showEditModal: false,
      triggerEditando: null,
      triggerEditandoIndex: -1,
      novoTrigger: {
        trigger: '',
        resposta: '',
        ativo: true,
        // minutes: '',
        // seconds: '',
      },
      tableFields: [
        {
          key: 'trigger',
          label: 'Trigger',
          sortable: true
        },
        {
          key: 'resposta',
          label: 'Resposta',
          sortable: false
        },
        /* {
          key: 'tempo',
          label: 'Ativação',
          sortable: true
        }, */
        {
          key: 'ativo',
          label: 'Status',
          sortable: true
        },
        {
          key: 'acoes',
          label: 'Ações',
          sortable: false
        }
      ]
    }
  },
  computed: {
    isFormValid() {
      return this.novoTrigger.trigger.trim() !== '' && 
             this.novoTrigger.resposta.trim() !== ''
             // (this.novoTrigger.minutes > 0 || this.novoTrigger.seconds > 0)
    }
  },
  watch: {
    webinarioData: {
      handler(newData) {
        if (newData) {
          this.carregarTriggersDoWebinario()
        }
      },
      immediate: true
    },
    triggers: {
      handler() {
        this.hasChanges = true
      },
      deep: true
    }
  },
  mounted() {
    this.carregarTriggersSalvos()
  },
  methods: {
    validarCaracteres(event) {
      const char = String.fromCharCode(event.keyCode)
      // Permite apenas letras, números e espaços (não permite caracteres especiais exceto #)
      const regex = /^[a-zA-Z0-9\s]$/
      
      // Se não for um caractere válido, previne a digitação
      if (!regex.test(char)) {
        event.preventDefault()
      }
    },

    formatarTrigger() {
      // Remove caracteres especiais exceto # e mantém apenas letras, números e espaços
      const valorLimpo = this.novoTrigger.trigger.replace(/[^a-zA-Z0-9\s#]/g, '')
      
      if (valorLimpo && !valorLimpo.startsWith('#')) {
        this.novoTrigger.trigger = `#${valorLimpo}`
      } else if (!valorLimpo) {
        this.novoTrigger.trigger = ''
      } else {
        this.novoTrigger.trigger = valorLimpo
      }
    },

    formatarTriggerEdicao() {
      // Remove caracteres especiais exceto # e mantém apenas letras, números e espaços
      const valorLimpo = this.triggerEditando.trigger.replace(/[^a-zA-Z0-9\s#]/g, '')
      
      if (valorLimpo && !valorLimpo.startsWith('#')) {
        this.triggerEditando.trigger = `#${valorLimpo}`
      } else if (!valorLimpo) {
        this.triggerEditando.trigger = ''
      } else {
        this.triggerEditando.trigger = valorLimpo
      }
    },

    formatTempo(segundos) {
      const mins = Math.floor(segundos / 60)
      const secs = segundos % 60
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    },
    
    carregarTriggersDoWebinario() {
      if (this.webinarioData && this.webinarioData.triggers) {
        try {
          let triggers = []
          // Se triggers é uma string JSON, parse it
          if (typeof this.webinarioData.triggers === 'string') {
            triggers = JSON.parse(this.webinarioData.triggers)
          } else if (Array.isArray(this.webinarioData.triggers)) {
            triggers = [...this.webinarioData.triggers]
          } else {
            triggers = []
          }
          
          // Normaliza triggers para sempre enviar tempo = 0
          this.triggers = triggers.map(trigger => ({
            ...trigger,
            tempo: 0, // Sempre enviar 0 por enquanto
          }))
          
          this.hasChanges = false
        } catch (error) {
          console.error('Erro ao carregar triggers do webinário:', error)
          this.triggers = []
        }
      }
    },

    carregarTriggersSalvos() {
      try {
        const triggersSalvos = localStorage.getItem('webinar_triggers')
        if (triggersSalvos) {
          this.triggers = JSON.parse(triggersSalvos)
          this.hasChanges = false
        }
      } catch (error) {
        console.error('Erro ao carregar triggers salvos:', error)
      }
    },

    adicionarTrigger() {
      if (!this.isFormValid) return

      // Verificar se já existe um trigger com a mesma palavra-chave
      const triggerExistente = this.triggers.find(t => 
        t.trigger.toLowerCase() === this.novoTrigger.trigger.toLowerCase()
      )

      if (triggerExistente) {
        this.$bvToast.toast('Já existe um trigger com essa palavra-chave', {
          title: 'Trigger Duplicado',
          variant: 'warning',
          solid: true
        })
        return
      }

      // Calcular tempo sempre como 0 por enquanto
      // const tempoTotalSegundos = (this.novoTrigger.minutes || 0) * 60 + (this.novoTrigger.seconds || 0)
      const tempoTotalSegundos = 0

      this.triggers.push({
        trigger: this.novoTrigger.trigger,
        resposta: this.novoTrigger.resposta,
        ativo: this.novoTrigger.ativo,
        tempo: tempoTotalSegundos,
        // minutes: this.novoTrigger.minutes || 0,
        // seconds: this.novoTrigger.seconds || 0,
      })

      // Limpar formulário
      this.novoTrigger = {
        trigger: '',
        resposta: '',
        ativo: true,
        // minutes: 1,
        // seconds: 0,
      }

      this.$bvToast.toast('Trigger adicionado com sucesso', {
        title: 'Sucesso',
        variant: 'success',
        solid: true,
      })
    },

    editarTrigger(index) {
      const trigger = this.triggers[index]
      // Não utilizar campos de tempo por enquanto
      // const tempoTotalSegundos = trigger.tempo || 0
      // const minutes = Math.floor(tempoTotalSegundos / 60)
      // const seconds = tempoTotalSegundos % 60
      
      this.triggerEditando = { 
        ...trigger,
        // minutes: minutes,
        // seconds: seconds,
      }
      this.triggerEditandoIndex = index
      this.showEditModal = true
    },

    salvarEdicao() {
      if (this.triggerEditando && this.triggerEditandoIndex >= 0) {
        // Verificar se já existe outro trigger com a mesma palavra-chave
        const triggerExistente = this.triggers.find((t, index) => 
          index !== this.triggerEditandoIndex && 
          t.trigger.toLowerCase() === this.triggerEditando.trigger.toLowerCase()
        )

        if (triggerExistente) {
          this.$bvToast.toast('Já existe outro trigger com essa palavra-chave', {
            title: 'Trigger Duplicado',
            variant: 'warning',
            solid: true
          })
          return
        }

        // Calcular tempo sempre como 0 por enquanto
        // const tempoTotalSegundos = (this.triggerEditando.minutes || 0) * 60 + (this.triggerEditando.seconds || 0)
        const tempoTotalSegundos = 0

        const triggerAtualizado = {
          trigger: this.triggerEditando.trigger,
          resposta: this.triggerEditando.resposta,
          ativo: this.triggerEditando.ativo,
          tempo: tempoTotalSegundos,
          // minutes: this.triggerEditando.minutes || 0,
          // seconds: this.triggerEditando.seconds || 0,
        }

        this.triggers.splice(this.triggerEditandoIndex, 1, triggerAtualizado)
        this.cancelarEdicao()

        this.$bvToast.toast('Trigger atualizado com sucesso', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })
      }
    },

    cancelarEdicao() {
      this.triggerEditando = null
      this.triggerEditandoIndex = -1
      this.showEditModal = false
    },

    toggleTriggerStatus(index) {
      this.triggers[index].ativo = !this.triggers[index].ativo
      
      this.$bvToast.toast(
        `Trigger ${this.triggers[index].ativo ? 'ativado' : 'desativado'} com sucesso`, 
        {
          title: 'Status Atualizado',
          variant: 'info',
          solid: true
        }
      )
    },

    removerTrigger(index) {
      this.$bvModal.msgBoxConfirm(
        `Tem certeza que deseja remover o trigger "${this.triggers[index].trigger}"?`,
        {
          title: 'Confirmar Remoção',
          okVariant: 'danger',
          okTitle: 'Remover',
          cancelTitle: 'Cancelar'
        }
      ).then(confirmed => {
        if (confirmed) {
          this.triggers.splice(index, 1)
          this.$bvToast.toast('Trigger removido com sucesso', {
            title: 'Sucesso',
            variant: 'success',
            solid: true
          })
        }
      })
    },

    limparTodos() {
      this.$bvModal.msgBoxConfirm(
        'Tem certeza que deseja remover todos os triggers configurados?',
        {
          title: 'Confirmar Limpeza',
          okVariant: 'danger',
          okTitle: 'Limpar Todos',
          cancelTitle: 'Cancelar'
        }
      ).then(confirmed => {
        if (confirmed) {
          this.triggers = []
          this.$bvToast.toast('Todos os triggers foram removidos', {
            title: 'Sucesso',
            variant: 'success',
            solid: true
          })
        }
      })
    },

    async salvarTriggers() {
      try {
        // Salvar no localStorage
        localStorage.setItem('webinar_triggers', JSON.stringify(this.triggers))

        // Sempre enviar para o backend
        const userData = localStorage.getItem('userData')
        const userId = userData ? JSON.parse(userData).id : null

        if (userId) {
          // Envia tempo sempre como 0 (sem conversão para milissegundos por enquanto)
          const triggersFormatted = this.triggers.map(trigger => ({
            trigger: trigger.trigger,
            resposta: trigger.resposta,
            ativo: trigger.ativo ? '1' : '0',
            tempo: 0, // Sempre enviar 0 por enquanto
          }))

          console.log('Triggers formatados para salvar:', triggersFormatted)

          // Monta o payload
          const payload = {
            user_id: userId,
            triggers: triggersFormatted,
          }

          console.log('Payload completo:', payload)

          await youtubeService.updateTriggers(payload)
        }

        this.hasChanges = false
        this.$emit('triggers-saved', this.triggers)

        this.$bvToast.toast('Configurações de triggers salvas com sucesso', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })
      } catch (error) {
        console.error('Erro ao salvar triggers:', error)
        this.$bvToast.toast('Erro ao salvar configurações. Tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    }
  }
}
</script>

<style scoped>
.gap-1 {
  gap: 0.25rem;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

code {
  font-size: 0.875rem;
}

.table-responsive {
  border-radius: 0.375rem;
}

.trigger-badge {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
  font-family: 'Monaco', 'Consolas', monospace;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.2s ease;
}

.trigger-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
}
</style>
